import { create } from "zustand";

export const useESUnlockModalStore = create((set) => ({
  modalOpen: false,
  setModalOpen: (value) => set({ modalOpen: value }),
}));
